module.exports = __webpack_public_path__ + "img/img_stgl4.a0d39218.png";